import React, { useState, useRef } from 'react';
import { AudioStyles } from 'styles/style';
import {
  FaPlay,
  FaPause,
  FaForward,
  FaBackward,
  FaVolumeUp,
  FaVolumeMute,
} from 'react-icons/fa';
import icon from '../../images/lra.svg';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const AudioContent = ({ audio, title }) => {
  const [song, setSong] = useState(audio);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(0.7);
  const [isMuted, setIsMuted] = useState(false);

  const audioRef = useRef(null);

  const skipTime = (seconds) => {
    if (audioRef.current) {
      const player = audioRef.current;
      player.currentTime = Math.min(
        Math.max(player.currentTime + seconds, 0),
        player.duration || player.currentTime
      );
    }
  };

  const skipBackTime = (seconds) => {
    if (audioRef.current) {
      const player = audioRef.current;
      player.currentTime = Math.min(
        Math.max(player.currentTime - seconds, 0),
        player.duration || player.currentTime
      );
    }
  };

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    setProgress(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const handleSeek = (e) => {
    const value = e.target.value;
    audioRef.current.currentTime = value;
    setProgress(value);
  };

  const handleVolume = (e) => {
    const value = e.target.value;
    setVolume(value);
    audioRef.current.volume = value;
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <AudioStyles.Section>
      <AudioStyles.PlayerCard>
        {song?.lyrics && (
          <>
            <AudioStyles.SongInfo>
              <AudioStyles.AlbumCover src={icon} alt="album" />
              <AudioStyles.SongText>
                <AudioStyles.SongTitle>
                  {song.title || title}
                </AudioStyles.SongTitle>
                <AudioStyles.SongArtist>Audio Content</AudioStyles.SongArtist>
              </AudioStyles.SongText>
            </AudioStyles.SongInfo>
            </>
            )}

            <AudioStyles.AudioControllerCont>
          <AudioStyles.ProgressWrapper>
            <AudioStyles.TimeRow>
              <span>
                {new Date(progress * 1000).toISOString().substr(14, 5)}
              </span>
              <span>
                {new Date(duration * 1000).toISOString().substr(14, 5)}
              </span>
            </AudioStyles.TimeRow>
            <AudioStyles.ProgressBar
              type="range"
              min="0"
              max={duration || 0}
              value={progress}
              onChange={handleSeek}
            />
          </AudioStyles.ProgressWrapper>

          <AudioStyles.SongControls>
            <AudioStyles.SongControlButton onClick={() => skipBackTime(10)}>
              <FaBackward />
            </AudioStyles.SongControlButton>
            <AudioStyles.PlayButton onClick={togglePlay}>
              {isPlaying ? <FaPause /> : <FaPlay />}
            </AudioStyles.PlayButton>
            <AudioStyles.SongControlButton onClick={() => skipTime(10)}>
              <FaForward />
            </AudioStyles.SongControlButton>
            <AudioStyles.SongControlButton onClick={toggleMute}>
              {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </AudioStyles.SongControlButton>
          </AudioStyles.SongControls>
        </AudioStyles.AudioControllerCont>

          {song?.lyrics && (
            <>
            <AudioStyles.LyricsBox>
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {song.lyrics}
              </ReactMarkdown>
            </AudioStyles.LyricsBox>
          </>
        )}
        {/* </AudioStyles.AudioControllerCont> */}

        

        {/* Audio Element */}
        {song.audio && (
          <audio
            ref={audioRef}
            src={`https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/${song.audio}.mp3`}
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
          />
        )}
      </AudioStyles.PlayerCard>
    </AudioStyles.Section>
  );
};

export default AudioContent;
